import { useTheme } from "next-themes";
import { Toaster as Sonner, ToasterProps } from "sonner";
import React from "react";
import {
  CircleAlertIcon,
  CircleCheckIcon,
  CircleXIcon,
} from "lucide-react";

const Toaster = ({ ...props }: ToasterProps) => {
  const { theme = "system" } = useTheme();

  return (
    <Sonner
      theme={theme as ToasterProps["theme"]}
      position="bottom-center"
      icons={{
        success: <CircleCheckIcon className="w-4 h-4" />,
        warning: <CircleAlertIcon className="w-4 h-4" />,
        error: <CircleXIcon className="w-4 h-4" />,
        info: <CircleAlertIcon className="w-4 h-4" />,
      }}
      style={
        {
          "--width": "420px",
        } as React.CSSProperties
      }
      toastOptions={{
        unstyled: true,
        classNames: {
          toast:
            "w-full text-white rounded-xl shadow-lg flex items-center gap-3 py-3 px-4",
          content: "flex-1 min-w-0 text-sm",
          icon: "flex-shrink-0",

          actionButton:
            "flex-shrink-0 px-3 py-1.5 rounded-md bg-white/20 hover:bg-white/30 text-xs font-medium transition-colors whitespace-nowrap",
          cancelButton:
            "flex-shrink-0 px-3 py-1.5 rounded-md bg-white/20 hover:bg-white/30 text-xs font-medium transition-colors whitespace-nowrap",

          title: "font-normal truncate",
          description: "font-normal text-white/80",

          success: "bg-primary text-primary-foreground",
          warning: "bg-system-warning",
          error: "bg-destructive text-destructive-foreground",
          info: "bg-secondary-600",
        },
      }}
      {...props}
    />
  );
};

export { Toaster };
